import React from "react";
import styles from './InputSwitch.styl'

class Switch extends React.Component {
	constructor(props) {
		super(props)
	}


	render() {
		let backgroundActive='#ffc93a'
			let roundDisabled='#ffc93a'
		if(this.props.type){
			if(this.props.type=='itk'){
				backgroundActive='#76d750'
				roundDisabled='#76d750'
			}
		}
		return (
			<div onClick={() => {
				this.props.onChange(this.props.id)
			}}
					 style={this.props.value ? {
						 background: backgroundActive
					 } : {background: '#e6eff1'}}
					 className={styles.toggleSwitch}>
				<div className={styles.knob}
						 style={this.props.value ? {left: '1.9em', borderColor: '#666'} : {
							 background: roundDisabled,
							 borderColor: roundDisabled
						 }}/>

			</div>
		)
	}
}

export default Switch;



// WEBPACK FOOTER //
// ./src/react/ui/features/InputSwitch.jsx